import { InvitadoLayout } from "layouts/invitado/invitadoLayout";
import React from "react";
import { Grid } from "@mui/material";
import { FormDatosQR } from "../components/FormDatosQR";

export const FormQrScanned = () => {
  return (
    <InvitadoLayout>
      <Grid container spacing={4} justifyContent="center">
        <Grid item sm={12} md={12} lg={8} xl={8}>
          <FormDatosQR />
        </Grid>
      </Grid>
    </InvitadoLayout>
  );
};
